import React from 'react';
import PropTypes from 'prop-types';

export default function TableHeaders({ isDarkMode }) {
  const thStyle = {
    color: isDarkMode ? '#dddddd' : '#212529',
    backgroundColor: isDarkMode ? '#232531' : '#f8f9fa',
    borderColor: isDarkMode ? '#434651' : '#dee2e6',
  };

  return (
    <thead style={{ backgroundColor: isDarkMode ? '#232531' : '#f8f9fa' }}>
      <tr>
        <th style={thStyle}>#</th>
        <th style={thStyle}>Setting Key</th>
        <th style={thStyle}>Setting Value</th>
        <th style={thStyle}>Access Control</th>
        <th style={thStyle}>Actions</th>
      </tr>
    </thead>
  );
}

TableHeaders.propTypes = {
  isDarkMode: PropTypes.bool.isRequired,
};
